/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding:10px 10%;background-color:#332323}.logo[_ngcontent-%COMP%]{cursor:pointer;color:#fff;font-size:large}.nav1[_ngcontent-%COMP%]{width:20%}.nav_links[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.nav_links[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:inline-block;cursor:pointer;text-transform:uppercase;list-style-type:none}.button[_ngcontent-%COMP%]{background-color:#302b2b;padding:5px 10%;color:#fff}"];
export { styles as styles };

